import { Switch } from "@cmp-src/primitives/Switch";
import { IResourcePermission } from "@gettactic/api";

type Props = {
  permission: IResourcePermission;
  onChange: (x: IResourcePermission) => void;
};

export function ApprovableCell({ permission, onChange }: Props) {
  const value = permission.is_approvable;

  return (
    <div className="my-2" onClick={(e) => e.stopPropagation()}>
      <Switch
        onCheckedChange={() => {
          onChange(permission);
        }}
        checked={!!value}
        className="col-span-2 ml-4 justify-self-end"
      />
    </div>
  );
}
